"use client";

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";
import { assetUrl } from "@/lib/assetUrl";

/**
 * Animated hammer icon for in-progress autofix indicators.
 *
 * The PNGs are APNG (Animated PNG) files – the browser plays the animation
 * natively, so no JS frame cycling is needed. Inline width/height/maxWidth
 * override Tailwind preflight (`img { max-width:100%; height:auto }`).
 *
 * Defaults to 16px so the autofix status slot matches every other pill
 * status icon; callers in tighter rows pass a smaller `size`.
 *
 * `inCircleBadge` nudges the glyph to optically center it inside the docked
 * pill's grey circle. The APNG canvas is 28×28, but the hammer artwork sits
 * ~2px right and ~5.5px low relative to center.
 */
export function AutofixHammerIcon(t0) {
  const $ = _c(18);
  const {
    className,
    size: t1,
    inCircleBadge: t2
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const inCircleBadge = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== size) {
    t3 = {
      width: size,
      height: size,
      maxWidth: "none"
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const imgStyle = t3;
  const t4 = inCircleBadge ? "block -translate-x-px -translate-y-px" : "inline-block";
  let t5;
  if ($[2] !== className || $[3] !== t4) {
    t5 = cn("relative shrink-0", t4, className);
    $[2] = className;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== size) {
    t6 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = assetUrl("autofix/hammer-light.png");
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== imgStyle) {
    t8 = <img src={t7} alt="" draggable={false} className="absolute inset-0 select-none dark:hidden" style={imgStyle} />;
    $[8] = imgStyle;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = assetUrl("autofix/hammer-dark.png");
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== imgStyle) {
    t10 = <img src={t9} alt="" draggable={false} className="absolute inset-0 hidden select-none dark:block" style={imgStyle} />;
    $[11] = imgStyle;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t5 || $[15] !== t6 || $[16] !== t8) {
    t11 = <span className={t5} style={t6} aria-hidden={true}>{t8}{t10}</span>;
    $[13] = t10;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}